import { getCookieScope } from '../modules/client/utilities'

export default ({ req, res, query }) => {
  if (process.server && query.btag) {
    try {
      res.cookie('btag', query.btag, {
        maxAge: 30 * 24 * 60 * 60 * 1000, // 1 month
        ...getCookieScope(req)
      })
    } catch (e) {
      if (
        e.message?.indexOf(
          'Cannot set headers after they are sent to the client'
        ) === -1
      )
        throw e
    }
  }
}
